import {Pipe, PipeTransform} from '@angular/core';

@Pipe ({
    name: 'toReverseHtml'
})

export class ToReverseHtmlPipe implements PipeTransform {
    
    transform(value: any, ...args: any[]) {
        return ToReverseHtmlPipe.reverseHtmlEntities(value);
    }

    public static reverseHtmlEntities(texte:string):string
    {
        texte = texte.replace(/&egrave;/g, 'è');
        texte = texte.replace(/&eacute;/g, 'é');
        texte = texte.replace(/&ecirc;/g, 'ê');
        texte = texte.replace(/&euml;/g, 'ë');
         
        texte = texte.replace(/&agrave;/g, 'à');
        texte = texte.replace(/&acirc;/g, 'ä');
        texte = texte.replace(/&auml;/g, 'â');
         
        texte = texte.replace(/&ograve;/g, 'ò');
        texte = texte.replace(/&ocirc;/g, 'ô');
        texte = texte.replace(/&ouml;/g, 'ö');
         
        texte = texte.replace(/&igrave;/g, 'ì');
        texte = texte.replace(/&icirc;/g, 'î');
        texte = texte.replace(/&iuml;/g, 'ï');
         
        texte = texte.replace(/&ugrave;/g, 'ù');
        texte = texte.replace(/&uuml;/g, 'ü');
        texte = texte.replace(/&ucirc;/g, 'û');

        texte = texte.replace(/&ccedil;/g, 'ç');
 
        return texte ;
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/toHtmlContent.pipe.ts